import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs/index';
import { STORE_FEATURE_KEY_APPOINTMENTS_LIST } from './appointment-list.reducers';

const viewDeletedRemindersSelector = (appState: any) => appState[STORE_FEATURE_KEY_APPOINTMENTS_LIST].viewDeletedReminders;
const viewVoidAppointmentsSelector = (appState: any) => appState[STORE_FEATURE_KEY_APPOINTMENTS_LIST].viewVoidAppointments;
const pageTypeSelector = (appState: any) => appState[STORE_FEATURE_KEY_APPOINTMENTS_LIST].pageType;

@Injectable()
export class AppointmentListSelectors {

    constructor(private store: Store<any>) {
    }

    selectViewDeletedReminder(): Observable<boolean> {
        return this.store
            .pipe(select(viewDeletedRemindersSelector));
    }

    selectViewVoidAppointments(): Observable<boolean> {
        return this.store
            .pipe(select(viewVoidAppointmentsSelector));
    }

    selectPageType(): Observable<string> {
        return this.store
            .pipe(select(pageTypeSelector));
    }

}
